import { AutocompleteListbox, AutocompleteListboxProps } from '@mui/joy';
import { Popper, PopperProps } from '@mui/base';
import { forwardRef } from 'react';

type Props = PopperProps & AutocompleteListboxProps;

const NoWrapListBoxAdapter = forwardRef<HTMLDivElement, Props>(
  ({ anchorEl, open, modifiers, ...rest }, ref) => (
    <Popper
      ref={ref}
      anchorEl={anchorEl}
      className="z-popperModal"
      modifiers={modifiers}
      open={open}
      placement="bottom-start"
    >
      <AutocompleteListbox {...rest} className="w-fit" size="sm" />
    </Popper>
  ),
);

export default NoWrapListBoxAdapter;
